import { render, staticRenderFns } from "./Taskaudit.vue?vue&type=template&id=b1693d96&scoped=true&"
import script from "./Taskaudit.vue?vue&type=script&lang=js&"
export * from "./Taskaudit.vue?vue&type=script&lang=js&"
import style0 from "./Taskaudit.vue?vue&type=style&index=0&id=b1693d96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1693d96",
  null
  
)

export default component.exports